// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1R0wf","actionsCol":"EnrolledClinics_actionsCol__1RzwJ"};